import { BlocksLayout } from 'blocks-nextjs/blocks-web-components/components/layout/layout';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatLayout = createComponent({ react: React, tagName: 'cat-layout', elementClass: BlocksLayout });
